import { vuexHandbook } from '@/store/compositionV2/module/handbook'

import { createIdRandom } from '@/utils/create'
import { mapTransport } from '@/utils/page/logistic'
import {
  LogisticDriverApi,
  LogisticFuelApi,
  LogisticObjectApi,
  LogisticTransportApi,
  LogisticWaybillApi
} from '@/api/Logistic'

const state = () => ({
  transportList: [],
  objectList: [],
  responsibleList: [],
  fuelList: [],
  driverList: []
})

const getters = {
  transportList: state => state.transportList.map(mapTransport),
  responsibleList: state => {
    return state.responsibleList.map(item => ({
      ...item,
      ...createIdRandom()
    }))
  }
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions(),
  async GETLogisticFuelList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      api: LogisticFuelApi,
      keyStateList: 'fuelList',
      search
    })
  },
  async GETLogisticTransportList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      api: LogisticTransportApi,
      keyStateList: 'transportList',
      search
    })
  },
  async GETLogisticObjectList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      api: LogisticObjectApi,
      keyStateList: 'objectList',
      search
    })
  },
  async GETLogisticDriverList ({ dispatch }, { search = null, expand = null } = {}) {
    await dispatch('GETRequest', {
      api: LogisticDriverApi,
      keyStateList: 'driverList',
      query: {
        expand
      },
      search
    })
  },
  async GETLogisticResponsibleList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      api: LogisticWaybillApi,
      method: 'getResponsible',
      keyStateList: 'responsibleList',
      query: {
        sort: 'responsible'
      },
      search
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
